import * as React from 'react';
import type { ResolveThunks } from 'react-redux';
import { connect } from 'react-redux';

import * as LMSActions from 'af-actions/learningManagementSystem';

interface DispatchProps {
	findCornerstoneResponse: typeof LMSActions.findCornerstoneResponse;
}

type Props = ResolveThunks<DispatchProps>;

const LearningManagementSystem: React.FC<Props> = (props) => {
	const { findCornerstoneResponse } = props;

	const login = React.useCallback(async () => {
		try {
			const res = await findCornerstoneResponse();

			if (!res?.acs || !res?.SAMLResponse) {
				console.error('Invalid SSO response, missing acs or SAMLResponse:', res);
				return;
			}

			const form = document.getElementById('sso') as HTMLFormElement | null;

			if (!form) {
				console.error('SSO form not found');
				return;
			}

			form.action = res.acs;

			const input = form.elements.namedItem('SAMLResponse') as HTMLInputElement | null;

			if (!input) {
				console.error('SAMLResponse input not found');
				return;
			}

			input.value = res.SAMLResponse;

			form.submit();
		} catch (error) {
			console.error('SSO login failed:', error);
		}
	}, [findCornerstoneResponse]);

	return (
		<>
			<li>
				<form autoComplete="off" id="sso" method="post" target="_blank">
					<input id="resp" name="SAMLResponse" type="hidden" />
				</form>
				<div onClick={login}>
					<span className={'icon-lms sidenav-icon'} />
					Learning Management System
				</div>
			</li>
		</>
	);
};

function mapDispatchToProps(): DispatchProps {
	return {
		findCornerstoneResponse: LMSActions.findCornerstoneResponse,
	};
}

export default connect<void, DispatchProps>(null, mapDispatchToProps())(LearningManagementSystem);
